module.exports = __webpack_public_path__ + "static/css-grid-9d90c8b580fbce29945f734297fa3f5c.png";